<template lang="html">
	<wizard-screen panel-class="omapi-panel__4" :completed="4" :total="5" :nav-prev="false" :nav-next="false">
		<h2>Connect Your Site with OptinMonster</h2>
		<core-alerts v-if="error" id="om-connect-errors" :alerts="alerts"></core-alerts>
		<div class="omapi-happy-text">
			OptinMonster is a powerful conversion toolkit that works on all website platforms. Create an account to
			connect your website with OptinMonster.
		</div>
		<div>
			<core-loading v-if="isLoading">
				<strong>Please wait...</strong>
			</core-loading>
			<wizard-next-link
				v-else
				ref="toFocus"
				type="button"
				class="omapi-button__large"
				text="Create a Free Account"
				@click.prevent="openCheckoutWindow"
			/>
		</div>
		<p class="omapi-happy-text__explainer">
			By connecting, you allow OptinMonster to create and send an API key to your WordPress site, allowing a
			secure connection and seamless integration to our app.
		</p>
		<div v-if="showProUpsells" class="omapi-box__gray">
			<h3>OptinMonster comes with a free license for WordPress users 😀</h3>
			<div>
				If you choose to upgrade to Pro, you will receive a <b>35% discount</b> - automatically applied at
				checkout.
			</div>
		</div>
	</wizard-screen>
</template>

<script lang="js">
import { getAppData } from '@/utils'
import { mapState, mapActions, mapGetters } from 'vuex'
import { screen } from './mixins/screen'

export default {
	mixins : [ screen ],
	computed : {
		...mapState([ 'error', 'alerts' ]),
		...mapGetters([ 'userEmail', 'userFirstName', 'userLastName', 'userId', 'showProUpsells' ]),
		...mapGetters('wp', [ 'isWooActive', 'isWooConnected' ]),
		isLoading () {
			return this.$store.getters.isLoading([ 'connect', 'wizard' ])
		},
		isDisabled () {
			return this.isLoading || !this.$store.state.apiKey
		},
	},
	mounted () {
		if (this.userId) {
			return this.skip()
		}

		this.$store.commit('clearAlerts')
		window.addEventListener('message', this.listenMessage)
	},
	beforeDestroy () {
		window.removeEventListener('message', this.listenMessage)
	},
	methods : {
		...mapActions([ 'saveApiKey' ]),
		listenMessage (evt) {
			const { origin, data } = evt
			if (origin.replace(/\/$/, '') !== this.$urls.app().replace(/\/$/, '')) {
				return
			}

			if (!data || 'string' !== typeof data) {
				return
			}

			try {
				// Get passed status.
				const data = JSON.parse(evt.data)

				if (!data.omWizard) {
					throw new Error('no')
				}

				// Do action based on status.
				switch (data.status) {
				case 'loaded':
					this.onCheckoutLoaded(data)
					break
				case 'registered':
					this.onCheckoutRegistered(data.apiKey)
					break
				case 'complete':
					window.location.reload()
					break
				default:
				}
			} catch (e) {

			}
		},
		openCheckoutWindow () {
			if (this.windowInterval) {
				return
			}

			let url = this.$urls.app('checkout/wp-plugin/')
			const partnerUrl = getAppData('partnerUrl')
			if (partnerUrl) {
				const urlObj = new URL(partnerUrl)
				urlObj.searchParams.set('urllink', url)
				url = urlObj.toString()
			}

			this.childWindow = window.open(
				url,
				'_blank',
				'width=700,height=700,left=200,top=100',
			)

			this.windowInterval = window.setInterval(() => {
				if (this.childWindow && this.childWindow.closed) {
					window.clearInterval(this.windowInterval)
					this.windowInterval = false
				}
			}, 1000)
		},
		onCheckoutLoaded () {
			const payload = {
				omWizard  : true,
				status    : 'loaded',
				origin    : window.location.protocol + '//' + window.location.host,
				siteName  : getAppData('blogname'),
				partnerId : getAppData('partnerId'),
				user      : {
					email     : this.userEmail,
					firstName : this.userFirstName,
					lastName  : this.userLastName,
				},
				onboarding : {
					via                      : 'wordpress',
					referred_by              : getAppData('referredBy'),
					woocommerce_active       : this.isWooActive,
					woocommerce_connected    : this.isWooConnected,
					usage                    : this.onboardingUsage,
					usage_other_text         : this.onboardingUsageOtherText,
					email_list               : this.onboardingEmailList,
					email_service            : this.onboardingEmailService,
					email_service_other_text : this.onboardingEmailServiceOtherText,
					goal                     : this.onboardingGoal,
					extra_features           : this.extraFeatures,
				},
			}

			this.childWindow.postMessage(JSON.stringify(payload), this.$urls.app())
		},
		onCheckoutRegistered (apiKey) {
			const done = () => {
				this.$store.commit('loading', 'wizard')

				window.location.reload()
			}
			this.saveApiKey(apiKey)
				.then(done)
				.catch(() => {
					// TODO Handle failures here.
					// What happens with user, etc? How can they proceed?
					done()
				})
		},
		canNextPage (proceed) {
			proceed.canProceed = false
			if (!this.isLoading) {
				this.openCheckoutWindow()
			}
		},
	},
};
</script>

<style scoped lang="scss">
.omapi-screen .omapi-panel__4 {
	.omapi-wizard-forward {
		border-radius: 3px;
		font-size: 16px;
		margin: 0 0 40px;
		padding: 16px 60px;
	}
	.om-circle-loading {
		margin: 0 0 20px;
	}

	.omapi-button__large {
		margin-bottom: 0 !important;
	}
}
</style>
